import PropTypes from "prop-types";
import Head from "next/head";
import config from "../../common/config";
import { APP_ID } from "../../common/constants";
import SEO from "../seo";
import { buildKeywords } from "../../lib/metaDataHelpers";
import { OneFraction } from "@/lib/helpers";

export default function RichOfficeMeta({ user = {} } = {}) {
  const {
    office_location,
    img: image,
    review,
    reviewsCount,
    name,
    type,
    status: isBlocked,
    paid,
    verified,
  } = user;
  if (!user || !paid || !verified || isBlocked || `${type}` !== "1")
    return (
      <Head>
        <title>{user.name}</title>
        <meta name="googlebot" content="noindex" />
        <meta name="robots" content="noindex" />
      </Head>
    );

  const ld = {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    name,
    image: `${config.IMAGES_CDN_BASE_URL}users/${image}`,
    openingHours: ["Su-Th 10:00-22:00", "Sa 16:00-22:00"],
    address: {
      "@type": "PostalAddress",
      addressCountry: "SA",
    },
    aggregateRating: review
      ? {
          "@type": "AggregateRating",
          bestRating: 5,
          worstRating: 0,
          ratingValue: OneFraction.format(review),
          ratingCount: reviewsCount,
        }
      : undefined,
  };
  return (
    <SEO
      title={user.name}
      description={user?.about || user.name}
      keywords={buildKeywords(["وسيط عقاري", "مكتب عقاري"])}
      metas={[
        { name: "apple-itunes-app", content: `app-id=${APP_ID}` },
        { property: "al:ios:app_store_id", content: `${APP_ID}` },
        { property: "al:ios:app_name", content: "عقار" },
      ]}
      structuredData={review ? JSON.stringify(ld) : undefined}
    />
  );
}
RichOfficeMeta.defaultProps = {
  user: undefined,
};
RichOfficeMeta.propTypes = {
  user: PropTypes.shape({
    office_location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    img: PropTypes.string,
    review: PropTypes.number,
    reviewsCount: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.number,
    paid: PropTypes.number,
    status: PropTypes.number,
    verified: PropTypes.number,
  }),
};
